import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreviewListingModule } from '@common/listing-preview/preview-listing.module';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { ReSelectModule } from '@common/re-select/re-select.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { LibraryMenuModule } from '../../library/private/library-menu/library-menu.module';
import { LibraryViewModeModule } from '../../library/private/library-view-mode/library-view-mode.module';
import { ListingPrimeNgModule } from '../listing-primeNg.module';
import { PropsRightBarComponent } from './props-rightbar.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { CurrencyPipeModule } from '@pipes/currency-pipe/currency.module';
import { AmTimeAgoModule } from '@pipes/time-ago/am-time-ago.module';
import { PriceInputModule } from '@common/price-input/price-input.module';
import { ListingPreviewComponent } from './preview-listing/preview-listing.component';

@NgModule({
  declarations: [PropsRightBarComponent, ListingPreviewComponent],
  imports: [
    FeatureFlagModule,
    CommonModule,
    ListingPrimeNgModule,
    CommonSharedModule,
    PreviewListingModule,
    LibraryMenuModule,
    LibraryViewModeModule,
    FullCalendarModule,
    GenaricNotesModule,
    FormsModule,
    ReactiveFormsModule,
    ReorderPipeModule,
    ReMultiselectModule,
    ReSelectModule,
    HistoryModule,
    ReMultipleSelectModule,
    CurrencyPipeModule,
    PriceInputModule,
    AmTimeAgoModule,
  ],
  exports: [PropsRightBarComponent, CommonModule],
})
export class PropsRightBarModule {}
